import ReactDOM from 'react-dom';

export default function PortalWrapper(props) {
    const container = document.getElementById(props.container);

    if (container == null) {
        return null;
    }

    return ReactDOM.createPortal(props.children, container);
}
